// Shared constants for Jobs screens

/**
 * Job type filter options
 */
export const JOB_TYPE_OPTIONS = [
  { id: 0, label: 'Locum' },
  { id: 1, label: 'Full-Time' },
  { id: 2, label: 'Temporary' },
  { id: 3, label: 'Contract' },
  { id: 4, label: 'International' },
];

/**
 * Date posted filter options
 */
export const DATE_POSTED_OPTIONS = [
  { value: '24hours', label: 'Last 24 hours', days: 1 },
  { value: '3days', label: 'Last 3 days', days: 3 },
  { value: '7days', label: 'Last 7 days', days: 7 },
  { value: '14days', label: 'Last 14 days', days: 14 },
  { value: '1month', label: 'Last month', days: 30 },
  { value: '3months', label: 'Last 3 months', days: 90 },
];

/**
 * Quick range options for shift date filter
 */
export const QUICK_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'tomorrow', label: 'Tomorrow' },
  { value: 'thisWeek', label: 'This Week' },
  { value: 'nextWeek', label: 'Next Week' },
];

/**
 * Profession type icons configuration
 */
export const professionTypeIcons = {
  'a': { icon: '👨‍⚕️', color: '#4B9BFF', bgColor: '#E3F2FF' },     // Doctor
  'b': { icon: '👩‍⚕️', color: '#10B981', bgColor: '#D1FAE5' },     // Nurse
  'c': { icon: '🦷', color: '#F59E0B', bgColor: '#FEF3C7' },      // Dentist
  'd': { icon: '🏥', color: '#8B5CF6', bgColor: '#EDE9FE' },      // Dental Surgery Assistant
  'e-x': { icon: '🩺', color: '#EF4444', bgColor: '#FEE2E2' },    // Medical Assistant
  'f-x': { icon: '📋', color: '#EC4899', bgColor: '#FCE7F3' },    // Clinic Assistant
  'g-x': { icon: '🔬', color: '#6366F1', bgColor: '#EEF2FF' },    // Research & Education
  'h-x': { icon: '🏠', color: '#14B8A6', bgColor: '#CCFBF1' },    // Caregiver
  'i-x': { icon: '📷', color: '#F97316', bgColor: '#FFEDD5' },    // Radiographer
  'j-x': { icon: '🔊', color: '#8B5CF6', bgColor: '#EDE9FE' },    // Sonographer
  'k-x': { icon: '💊', color: '#22C55E', bgColor: '#DCFCE7' },    // Pharmacist
  'l-x': { icon: '🧪', color: '#3B82F6', bgColor: '#DBEAFE' },    // Laboratory
  'm-x': { icon: '🔧', color: '#64748B', bgColor: '#F1F5F9' },    // Technician
  'n-x': { icon: '⚙️', color: '#71717A', bgColor: '#F4F4F5' },    // Technologist
  'o-x': { icon: '🏃', color: '#0EA5E9', bgColor: '#E0F2FE' },    // Physiotherapist
  'p-x': { icon: '🧠', color: '#D946EF', bgColor: '#FAE8FF' },    // Therapist
  'q-x': { icon: '⚕️', color: '#059669', bgColor: '#D1FAE5' },    // Allied Health
  'r-x': { icon: '🩹', color: '#78716C', bgColor: '#F5F5F4' },    // Healthcare Support
  's-x': { icon: '👔', color: '#0891B2', bgColor: '#CFFAFE' },    // Healthcare Management
  't-x': { icon: '🏢', color: '#7C3AED', bgColor: '#EDE9FE' },    // Non-Healthcare Management
  'u-x': { icon: '🛠️', color: '#CA8A04', bgColor: '#FEF9C3' },    // Non-Healthcare Support
  'default': { icon: '💼', color: '#6B7280', bgColor: '#F3F4F6' }
};

/**
 * Profession labels mapping
 */
export const professionLabels = {
  'doctor': 'Doctor',
  'nurse': 'Nurse',
  'pharmacist': 'Pharmacist',
  'physiotherapist': 'Physiotherapist',
  'dentist': 'Dentist',
  'radiographer': 'Radiographer',
  'lab_technician': 'Lab Technician',
  'paramedic': 'Paramedic'
};
